/* LarpLife theme — reads catalog.json (vendor names only, no supplier URLs)
   and wires the nav, stats, category counts, product vendor list and directory. */

(function () {
  'use strict';

  var fmt = function (n) { return Number(n).toLocaleString('en-GB'); };
  var esc = function (s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };

  var LOCK =
    '<span class="vlock"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linejoin="round" aria-hidden="true"><rect x="4.8" y="10.6" width="14.4" height="9.6" rx="1.4"/>' +
    '<path d="M8.2 10.6V7.8a3.8 3.8 0 0 1 7.6 0v2.8"/></svg>Locked</span>';

  /* ------------------------------------------------------------- chrome -- */
  function initChrome() {
    var toggle = document.querySelector('.nav-toggle');
    var links = document.querySelector('.nav-links');
    if (toggle && links) {
      toggle.addEventListener('click', function () {
        var open = links.classList.toggle('open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }
  }

  /* Product handles look like "larplife-clothing"; catalog slugs like "clothing".
     Shopify auto-generates handles from titles if one is ever left unset
     ("clothing-supplier-links"), so strip both shapes rather than assuming one. */
  function slugFromHandle(handle) {
    return String(handle || '')
      .replace(/^larplife-/, '')
      .replace(/-supplier-links$/, '');
  }

  /* --------------------------------------------------------------- data -- */
  function loadCatalog() {
    var url = (window.LARPLIFE && window.LARPLIFE.catalogUrl) || '';
    if (!url) return Promise.reject(new Error('no catalog url'));
    return fetch(url, { cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('catalog ' + r.status);
      return r.json();
    });
  }

  /* -------------------------------------------------------------- stats -- */
  function fillStats(cat) {
    document.querySelectorAll('[data-stat]').forEach(function (el) {
      var k = el.getAttribute('data-stat');
      if (k === 'vendors') el.textContent = fmt(cat.totalVendors);
      else if (k === 'suppliers') el.textContent = fmt(cat.uniqueSuppliers);
      else if (k === 'categories') el.textContent = cat.categories.length;
    });
  }

  /* ------------------------------------------------- category card counts -- */
  function fillCounts(cat) {
    var bySlug = {};
    cat.categories.forEach(function (c) { bySlug[c.slug] = c; });

    document.querySelectorAll('.cat-card[data-handle]').forEach(function (card) {
      var c = bySlug[slugFromHandle(card.getAttribute('data-handle'))];
      var el = card.querySelector('[data-count]');
      if (!el) return;
      el.textContent = c ? fmt(c.count) + ' listings' : 'All categories';
    });

    var meta = document.querySelector('[data-buy-meta]');
    if (meta) {
      var c = bySlug[slugFromHandle(meta.getAttribute('data-handle'))];
      if (c) meta.textContent = fmt(c.count) + ' supplier links · one-off · instant delivery';
      else meta.textContent = fmt(cat.totalVendors) + ' supplier links · one-off · instant delivery';
    }
  }

  /* ------------------------------------------- product page vendor list -- */
  function initProductList(cat) {
    var listEl = document.getElementById('ProductVendorList');
    if (!listEl) return;

    var slug = slugFromHandle(listEl.getAttribute('data-handle'));
    var entry = cat.categories.filter(function (c) { return c.slug === slug; })[0];

    // all-access product: show every vendor, tagged with its category
    var rows = entry
      ? entry.vendors.map(function (v) { return { name: v, cat: entry.name }; })
      : cat.categories.reduce(function (acc, c) {
          return acc.concat(c.vendors.map(function (v) { return { name: v, cat: c.name }; }));
        }, []).sort(function (a, b) { return a.name.localeCompare(b.name); });

    var searchEl = document.getElementById('ProductVendorSearch');
    var countEl = document.getElementById('ProductVendorCount');
    var LIMIT = 400;

    function render() {
      var q = (searchEl && searchEl.value || '').trim().toLowerCase();
      var items = q ? rows.filter(function (r) { return r.name.toLowerCase().indexOf(q) !== -1; }) : rows;

      if (countEl) countEl.textContent = fmt(items.length) + ' / ' + fmt(rows.length);

      if (!items.length) {
        listEl.innerHTML = '<div class="empty">Nothing matches that search.</div>';
        return;
      }

      var shown = items.slice(0, LIMIT);
      listEl.innerHTML = shown.map(function (r) {
        return '<div class="vrow"><span class="vname">' + esc(r.name) + '</span>' +
               '<span class="vcat">' + esc(r.cat) + '</span>' + LOCK + '</div>';
      }).join('') +
      (items.length > LIMIT
        ? '<div class="empty">+ ' + fmt(items.length - LIMIT) + ' more — search to narrow the list.</div>'
        : '');
    }

    if (searchEl) {
      var t;
      searchEl.addEventListener('input', function () {
        clearTimeout(t); t = setTimeout(render, 120);
      });
    }
    render();
  }

  /* ---------------------------------------------------- directory page -- */
  function initDirectory(cat) {
    var listEl = document.getElementById('DirList');
    if (!listEl) return;

    var searchEl = document.getElementById('DirSearch');
    var filterEl = document.getElementById('DirFilter');
    var countEl = document.getElementById('DirCount');
    var moreEl = document.getElementById('DirMore');
    var moreWrap = document.getElementById('DirMoreWrap');
    var PAGE = 120;
    var shown = PAGE;

    if (filterEl) {
      filterEl.innerHTML = '<option value="">All categories</option>' +
        cat.categories.map(function (c) {
          return '<option value="' + c.slug + '">' + esc(c.name) + ' (' + fmt(c.count) + ')</option>';
        }).join('');
    }

    var rows = cat.categories.reduce(function (acc, c) {
      return acc.concat(c.vendors.map(function (v) { return { name: v, cat: c.name, slug: c.slug }; }));
    }, []).sort(function (a, b) { return a.name.localeCompare(b.name); });

    function filtered() {
      var q = (searchEl && searchEl.value || '').trim().toLowerCase();
      var f = filterEl ? filterEl.value : '';
      return rows.filter(function (r) {
        return (!f || r.slug === f) && (!q || r.name.toLowerCase().indexOf(q) !== -1);
      });
    }

    function render() {
      var items = filtered();
      if (countEl) countEl.textContent = fmt(items.length) + ' / ' + fmt(rows.length);

      if (!items.length) {
        listEl.innerHTML = '<div class="empty">No vendors match that search.</div>';
        if (moreWrap) moreWrap.hidden = true;
        return;
      }

      listEl.innerHTML = items.slice(0, shown).map(function (r) {
        return '<div class="vrow"><span class="vname">' + esc(r.name) + '</span>' +
               '<span class="vcat">' + esc(r.cat) + '</span>' + LOCK + '</div>';
      }).join('');

      var remaining = items.length - shown;
      if (moreWrap) moreWrap.hidden = remaining <= 0;
      if (moreEl && remaining > 0) {
        moreEl.textContent = 'Show ' + fmt(Math.min(remaining, PAGE)) + ' more';
      }
    }

    if (searchEl) {
      var t;
      searchEl.addEventListener('input', function () {
        clearTimeout(t); t = setTimeout(function () { shown = PAGE; render(); }, 120);
      });
    }
    if (filterEl) filterEl.addEventListener('change', function () { shown = PAGE; render(); });
    if (moreEl) moreEl.addEventListener('click', function () { shown += PAGE; render(); });

    render();
  }

  /* ---------------------------------------------------------------- go -- */
  function boot() {
    initChrome();
    loadCatalog().then(function (cat) {
      fillStats(cat);
      fillCounts(cat);
      initProductList(cat);
      initDirectory(cat);
    }).catch(function (err) {
      console.error('[LarpLife]', err);
      var d = document.getElementById('DirList');
      if (d) d.innerHTML = '<div class="empty">Directory data unavailable.</div>';
      var p = document.getElementById('ProductVendorList');
      if (p) p.innerHTML = '<div class="empty">Vendor list unavailable.</div>';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
